class DashboardService {
  constructor() {}
  resources = () => ({
    dashboard: {
      uri: `/v1/actas/actasacuerdosdashboard`,
      method: ['get']
    },
    cargarAnios: {
      uri: `/v1/actas/aniosactas`,
      method: ['get']
    }
  });
}

export default DashboardService;
